import { createAction, props } from '@ngrx/store';
import {
  TimeTrackingServiceCreateResponseJson,
  TimeTrackingServiceGetResponse,
} from '@vmspdb/definitions';

export const deleteTimeTracking = createAction(
  '[TimeTracking/API] Delete TimeTracking',
  props<{ item: TimeTrackingServiceCreateResponseJson }>(),
);

export const clearTimeTrackings = createAction(
  '[TimeTracking/API] Clear TimeTrackings',
);

export const fetchMyTimeTracking = createAction(
  '[TimeTracking/API] Fetch My TimeTrackings',
);

export const loadMyTimeTracking = createAction(
  '[TimeTracking/API] Load My TimeTrackings',
  props<{ mine?: TimeTrackingServiceGetResponse }>(),
);

export const startMyTimeTrackingForSurvey = createAction(
  '[TimeTracking/API] Start My TimeTracking for Survey',
  props<{ projectUuid: string; projectSurveyTaskUuid: string }>(),
);

export const stopMyTimeTrackingForSurvey = createAction(
  '[TimeTracking/API] Stop My TimeTracking for Survey',
  props<{ projectUuid: string; projectSurveyTaskUuid: string }>(),
);

export const loadMyTimeTrackingError = createAction(
  '[TimeTracking/API] Load My TimeTrackings',
  props<{ error: any }>(),
);

export const clearMyTimeTracking = createAction(
  '[TimeTracking/API] Clear My TimeTrackings',
);
